<template>
	<div class="top-menu" :style="{paddingBottom: !(curMenuItem && curMenuItem.path != '/index') ? 'calc(52px * var(--scale-rate))' : 'calc(10px * var(--scale-rate))'}">
		<div class="inline-between main-line">
			<img class="logo-banner" src="~@/assets/logo2.png" @click="onClickHomeLogo()" />
			<div class="inline-between" style="position: relative; flex: 1;">
				<search-bar />
				<el-tooltip class="item" effect="dark" placement="bottom-end"
					v-model="tipVisible" popper-class="popperclass2" :visible-arrow="false">
					<div slot="content" class="menu-list" :style="{'--scale-rate': scaleRate(), 
						marginTop: (30 * scaleRate()) + 'px'}">
						<div class="inline-column menu-item" v-for="(item, idx) in menuListV" :key="idx"
							 @click="onClickMenuItem(idx)">
							<div class="caption">{{item.caption}}</div>
							<div class="caption-en">{{item.captionEn}}</div>
						</div>
					</div>
					<img class="menu-icon" src="~@/assets/svg/icon-menu.svg" />
				</el-tooltip>
			</div>
		</div>
		<div class="inline-start divider" v-if="curMenuItem && curMenuItem.path != '/index'">
			<img class="list-icon" src="~@/assets/list-icon.png" />
			<div class="inline-column caption">
				<span class="zh">{{curMenuItem.caption}}</span>
				<div class="en">{{curMenuItem.captionEn}}  ------------------------------------------------------------------------------------------------------------------------------------</div>
			</div>
			<i class="el-icon-arrow-down"></i>
		</div>
		<div class="mask" v-if="tipVisible">
			
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import MenuMixin from '../mixins/menuMixin.js';
	import SearchBar from '@/components/searchBar/indexV';
	export default {
		name: 'ChannelList',
		mixins: [MenuMixin],
		components: {
			SearchBar
		},
		data() {
			return {
				tipVisible: false,
			}
		},
		computed: {
			itemBgStyle() {
				if (this.curIdx < 0) return {
					display: 'none'
				};
				return {
					top: 'calc(' + ((72 + 9) * this.curIdx) + 'px * var(--scale-rate))'
				}
			},
			curMenuItem() {
				if(this.curIdx >= 0 && this.curIdx <=4) {
					return this.menuList[this.curIdx];
				}
				const item = this.otherMenus.filter(it => it.path == this.$route.path)[0];
				return item;
			},
			menuListV() {
				let lst = JSON.parse(JSON.stringify(this.menuList));
				return lst.concat(this.otherMenus.filter(it => ['/sample', '/contactUs'].includes(it.path)));
			}
		},
		methods: {
			...mapGetters(["scaleRate"]),
			onClickMenuItem(idx) {
				this.curIdx = idx;	
				this.$router.push({path: this.menuListV[idx].path});
			}
		}
	}
</script>

<style scoped lang="less">
	.top-menu {
		padding: calc(50px * var(--scale-rate)) calc(60px * var(--scale-rate)) calc(10px * var(--scale-rate)) calc(56px * var(--scale-rate));
		width: 100%;
		overflow: hidden;
		
		.main-line {
			width: 100%;
		}
		
		.divider {
			width: 100%;
			margin-top: calc(30px * var(--scale-rate));
			overflow: hidden;
			position: relative;
			
			.el-icon-arrow-down {
				position: absolute;
				right: 0;
			}
			
			.list-icon {
				width: calc(46px * var(--scale-rate));
				height: calc(46px * var(--scale-rate));
				margin-left: calc(7px * var(--scale-rate));
			}
			
			.caption {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				margin-left: 14px;
				//margin-top: 10px;
				line-height: 1;
				transform: scale(var(--scale-rate));
				transform-origin: left center;
			
				.zh {
					font-size: 41px;
					letter-spacing: 1.4px;
				}
			
				.en {
					width: 100%;
					font-size: 17px;
					letter-spacing: -0.8px;
					color: rgb(39, 38, 54);
					margin-top: 2px;
					margin-left: 40px;
					white-space: nowrap;
					overflow: hidden;
				}
			}
		}

		.logo-banner {
			width: calc(318px * var(--scale-rate));
			height: calc(85px * var(--scale-rate));
			cursor: pointer;
		}

		.menu-icon {
			width: calc(57px * var(--scale-rate));
			height: calc(42px * var(--scale-rate));
			margin: calc(17px * var(--scale-rate));
		}
	}
	.menu-list {
	
		.menu-item {
			cursor: pointer;
			width: calc(378px * var(--scale-rate));
			height: calc(93px * var(--scale-rate));
			margin-top: calc(30px * var(--scale-rate));
			background-image: url('~@/assets/left-menu-bg2.png');
			background-size: auto 100%;
			background-position: left center;
			background-repeat: no-repeat;
			z-index: 10;
			line-height: var(--scale-rate);
	
			.caption {
				display: inline-block;
				white-space: nowrap;
				//font-weight: 500;
				font-size: 39px;
				transform: scale(var(--scale-rate));
				letter-spacing: calc(2px * var(--scale-rate));
				margin-top: calc(10px * var(--scale-rate));
			}
	
			.caption-en {
				display: inline-block;
				white-space: nowrap;
				font-size: 19px;
				transform: scale(var(--scale-rate));
				-ms-transform: scale(var(--scale-rate));
				-webkit-transform: scale(var(--scale-rate));
				margin-top: calc(7px * var(--scale-rate));
				letter-spacing: calc(-0.8px * var(--scale-rate));
			}
		}
	}
	.mask {
		position: fixed;
		top: calc(187px * var(--scale-rate));
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(250, 250, 250, .2);
		backdrop-filter: blur(5px);
	}
</style>
<style lang="less">
	.popperclass2 {
		background: transparent !important;
		border: none;
		//padding: 0 0 5px 5px !important;
		transform: translateX(30%);
	}
</style>